import { IonContent } from '@ionic/react';
import React from 'react';

import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import './AppUsers.scss';

export const OnboardingReplikaAppUsers: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Pheon Users',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <OnboardingPage background="none" className="onboarding-app-users">
      <IonContent className="content">
        <div className="image-container">
          <img
            src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/AppUsers/planet_static.png"
            alt="planet"
          />
        </div>
        <div className="description">
          <OnboardingTitle color="white">
            Trusted by 1,556,867 users
          </OnboardingTitle>
          <OnboardingSubtitle color="neutral-white">
            They have already discovered the value that Dialogue brings to their
            lives
          </OnboardingSubtitle>
        </div>
      </IonContent>

      <OnboardingFooter onContinue={handleNextStep} />
    </OnboardingPage>
  );
};
